/**
 * 登入 / 登出後廣播的事件名稱。
 *
 * SystemProvider 掛在 AuthProvider 外層（見 App.tsx），拿不到登入狀態，
 * 但它載入的系統設定裡有只在登入後才拿得到的欄位（profileRequiredFields）。
 * 靠這個事件讓外層 Provider 在身分改變時重抓資料。
 */
export const AUTH_CHANGED_EVENT = 'auth:changed'
